import MDinput from '@/components/MDinput';
import InputNumber from '@/components/DSE/InputNumber';
import Select from '@/components/DSE/Select';
import EditorLabel from '@/components/DSE/EditorLabel';
import { validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    useExistingLabel: {
      type: EditorLabel,
      hideOnEdit: true,
      props: {
        caption: 'common.emptyString',
        label: 'orderLine.useExistingPrice'
      }
    },
    priceListItemID: {
      type: Select,
      hideOnEdit: true,
      props: {
        caption: 'common.emptyString',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['priceListItem/isLoading'],
        options: vue.$store.getters['priceListItem/loadedItems'].filter(
          pli => pli.domainID === vue.$parent.form.model.domainID
        )
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    priceListItemQuantity: {
      type: InputNumber,
      defaultValue: 1,
      hideOnEdit: true,
      props: {
        caption: 'orderLine.quantity',
        min: 0,
        precision: 2
      },
      dynamicProps: form => ({
        required: form.priceListItemID === undefined
      })
    },
    // createLabel: {
    //   type: EditorLabel,
    //   hideOnEdit: true,
    //   props: {
    //     caption: 'common.emptyString',
    //     label: 'orderLine.createNewPrice'
    //   }
    // },
    description: {
      type: MDinput,
      defaultValue: '',
      hideOnCreate: true,
      props: {
        maxlength: 64
      },
      dynamicProps: form => ({
        readonly: (form.initialPrice && !form.initialPrice !== 0) || typeof form.priceListItemID !== 'undefined',
        required: form.priceListItemID === undefined
      })
    },
    price: {
      type: InputNumber,
      defaultValue: 0,
      hideOnCreate: true,
      props: {
        min: 0,
        precision: 2
      },
      dynamicProps: form => ({
        disabled: (form.initialPrice && !form.initialPrice !== 0) || typeof form.priceListItemID !== 'undefined',
        required: form.priceListItemID === undefined
      })
    },
    quantity: {
      type: InputNumber,
      defaultValue: 0,
      hideOnCreate: true,
      props: {
        caption: 'orderLine.quantity',
        min: 0
      },
      dynamicProps: form => ({
        disabled: (form.initialPrice && !form.initialPrice !== 0) || typeof form.priceListItemID !== 'undefined',
        required: form.priceListItemID === undefined
      })
    },
    unit: {
      type: Select,
      defaultValue: null,
      hideOnCreate: true,
      props: {
        caption: 'priceListItem.unit',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('capacityUnit')
      },
      dynamicProps: form => ({
        readonly: (form.initialPrice && !form.initialPrice !== 0) || typeof form.priceListItemID !== 'undefined',
        required: form.priceListItemID === undefined
      })
    },
    discountPercentage: {
      type: InputNumber,
      defaultValue: 0,
      hideOnCreate: true,
      props: {
        caption: 'orderLine.discountPercentage',
        min: 0,
        max: 100
      },
      dynamicProps: form => ({
        readonly: (form.initialPrice && !form.initialPrice !== 0) || typeof form.priceListItemID !== 'undefined',
        required: form.priceListItemID === undefined
      })
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  item.initialPrice = item.price;
  return {
    ...item
  };
}
